var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameController(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "game-controller_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 25 25",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".game-controller_svg__st0{fill:none;stroke:currentColor;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "game-controller_svg__Icon_-_eSports",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-controller_svg__Video-Games_Video-Games-Controller_video-game-controller-team",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-controller_svg__Group_76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-controller_svg__Light_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_773",
    className: "game-controller_svg__st0",
    d: "M10.8 12.3c-3.9 0-3.2 5.9-6.9 5.9-2.1-.1-3.8-1.9-3.7-4V7.3c0-3.9 3.1-7 7-7h9c3.9 0 7 3.1 7 7v6.8c.2 2.1-1.4 4-3.5 4.1h-.1c-3.7 0-3-5.9-6.9-5.9h-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_774",
    className: "game-controller_svg__st0",
    d: "M6.2 4.9v4.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_775",
    className: "game-controller_svg__st0",
    d: "M8.6 7.3H3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_776",
    className: "game-controller_svg__st0",
    d: "M17.2 5.1c.1 0 .2.1.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_777",
    className: "game-controller_svg__st0",
    d: "M17 5.3c0-.1.1-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_778",
    className: "game-controller_svg__st0",
    d: "M17.2 5.6c-.1 0-.2-.1-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_779",
    className: "game-controller_svg__st0",
    d: "M17.5 5.3c0 .1-.1.2-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_780",
    className: "game-controller_svg__st0",
    d: "M15.2 7.1c.1 0 .2.1.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_781",
    className: "game-controller_svg__st0",
    d: "M15 7.3c0-.1.1-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_782",
    className: "game-controller_svg__st0",
    d: "M15.2 7.6c-.1 0-.2-.1-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_783",
    className: "game-controller_svg__st0",
    d: "M15.5 7.3c0 .1-.1.2-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_784",
    className: "game-controller_svg__st0",
    d: "M17.2 9.1c.1 0 .2.1.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_785",
    className: "game-controller_svg__st0",
    d: "M17 9.3c0-.1.1-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_786",
    className: "game-controller_svg__st0",
    d: "M17.2 9.6c-.1 0-.2-.1-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_787",
    className: "game-controller_svg__st0",
    d: "M17.5 9.3c0 .1-.1.2-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_788",
    className: "game-controller_svg__st0",
    d: "M19.2 7.1c.1 0 .2.1.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_789",
    className: "game-controller_svg__st0",
    d: "M19 7.3c0-.1.1-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_790",
    className: "game-controller_svg__st0",
    d: "M19.2 7.6c-.1 0-.2-.1-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Shape_791",
    className: "game-controller_svg__st0",
    d: "M19.5 7.3c0 .1-.1.2-.2.2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "game-controller_svg__Path_7",
    className: "game-controller_svg__st0",
    d: "M6.2.3c2.8 0 5 2.2 5 5"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgGameController as ReactComponent };